function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var __generator = this && this.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
import { ofType } from "redux-observable";
import { of, from } from "rxjs";
import { catchError, map, mergeMap, takeUntil } from "rxjs/operators";
import { SEARCH_BEGIN, SEARCH_CANCELLED, logError, searchSuccess, searchCanceled } from "../actions";
import SocialAPIUtils from "../utils/SocialAPIUtils";
import Tracker from "../utils/piwik";
import FlexSearch from "flexsearch/dist/flexsearch.compact";
import "flexsearch/lang/de";
import "flexsearch/lang/en";
import { getActiveGroups } from "../utils/SocialGroupsUtils";
export var search = function() {
    var _ref = _asyncToGenerator(function(state, query) {
        var _instance, slides, re, index, result, foundIds, bm, ns, notes, _tmp, spheres, community, _tmp1;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    slides = [];
                    re = new RegExp(query, "gi");
                    index = new FlexSearch("match", {
                        async: true,
                        stemmer: state.intl.locale || false,
                        doc: {
                            id: "id",
                            field: [
                                "search",
                                "name"
                            ]
                        }
                    });
                    index.add(state.searchableSlides);
                    return [
                        4,
                        index.search(query)
                    ];
                case 1:
                    result = _state.sent();
                    foundIds = result.map(function(r) {
                        return r.id;
                    });
                    slides = state.nodes.filter(function(n) {
                        return foundIds.indexOf(n.id) > -1;
                    });
                    bm = (_instance = []).concat.apply(_instance, _toConsumableArray(Object.values(state.bonusMaterial))).filter(function(b) {
                        return !!b.name.match(re) || !!b.alt.match(re);
                    });
                    ns = state.groups.noteGroup;
                    _tmp = ns;
                    if (!_tmp) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        SocialAPIUtils.searchTopics({
                            query: query,
                            spheres: [
                                ns.id
                            ]
                        })
                    ];
                case 2:
                    _tmp = _state.sent();
                    _state.label = 3;
                case 3:
                    notes = _tmp || [];
                    spheres = getActiveGroups().map(function(s) {
                        return s.id;
                    });
                    _tmp1 = spheres.length;
                    if (!_tmp1) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        SocialAPIUtils.searchTopics({
                            query: query,
                            spheres: spheres
                        })
                    ];
                case 4:
                    _tmp1 = _state.sent();
                    _state.label = 5;
                case 5:
                    community = _tmp1 || [];
                    Tracker.trackEvent("DoSearch", "query: ".concat(query));
                    return [
                        2,
                        {
                            slides: slides,
                            bm: bm,
                            notes: notes,
                            community: community
                        }
                    ];
            }
        });
    });
    return function search(state, query) {
        return _ref.apply(this, arguments);
    };
}();
export default function doSearch(action$, state$) {
    return action$.pipe(ofType(SEARCH_BEGIN), mergeMap(function(action) {
        return action.query ? from(search(state$.value, action.query)).pipe(map(function(results) {
            return searchSuccess({
                search: {
                    query: action.query,
                    results: results
                }
            });
        }), takeUntil(action$.pipe(ofType(SEARCH_BEGIN, SEARCH_CANCELLED))), catchError(function(error) {
            return of(logError({
                error: error,
                key: "search"
            }));
        })) : of(searchCanceled());
    }), catchError(function(error) {
        return of(logError({
            error: error,
            key: "search"
        }));
    }));
}
